webpackJsonp([154382131621592],{

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(30);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _landingModule = __webpack_require__(250);
	
	var _landingModule2 = _interopRequireDefault(_landingModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'span',
	  null,
	  'Get started!'
	);
	
	var LandingPage = function LandingPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: _landingModule2.default.landing },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h1',
	        { className: _landingModule2.default.landing__header },
	        'react-permissible'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: _landingModule2.default.landing__subheader },
	        'Making the permission management for components easier.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _landingModule2.default.btn__wrapper },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/docs/getting-started/overview', className: _landingModule2.default.landing__btn },
	          _ref
	        )
	      )
	    )
	  );
	};
	
	exports.default = LandingPage;
	module.exports = exports['default'];

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"landing":"src-pages----landing-module---landing---1T43_","landing__header":"src-pages----landing-module---landing__header---160Ei","btn__wrapper":"src-pages----landing-module---btn__wrapper---HNJ4r","landing__btn":"src-pages----landing-module---landing__btn---3l1u1","landing__btn--alt":"src-pages----landing-module---landing__btn--alt---2RmQX src-pages----landing-module---landing__btn---3l1u1"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-landing-js-074822dcc889e40fb64e.js